(function ($) {
    // Carousels
    if(jQuery().slick && $('.img-carousel').length) {
		
    	$('.img-carousel').each(function () {
    		var nav = $(this).parent().find('.img-carousel-nav').attr('id');
    		nav = '#' + nav;
    		$(this).slick({
    			slidesToShow: 1,
    			slidesToScroll: 1,
    			arrows: true,
    			fade: true,
    			adaptiveHeight: true,
    			asNavFor: nav
    		});
    	});
        
    	if ($('body').hasClass('pagemode-edit')) {
    		$('.img-carousel-nav').each(function () {
    			var carousel = $(this).parent().parent().find('.img-carousel').attr('id');
    			carousel = '#' + carousel;
    			$(this).slick({
    				slidesToShow: 4,
    				slidesToScroll: 1,
    				asNavFor: carousel,
    				arrows: true,
    				focusOnSelect: true,
    				infinite: false
    			});
    		});
        } else {
    		$('.img-carousel-nav').each(function () {
    			var carousel = $(this).parent().parent().find('.img-carousel').attr('id');
    			carousel = '#' + carousel;
    			$(this).slick({
        			slidesToShow: 4,
        			slidesToScroll: 1,
        			asNavFor: carousel,
        			arrows: true,
        			focusOnSelect: true
    			});
    		});

    		//Lightbox
    		$('.img-carousel').each(function () {
    			$(this).featherlightGallery({
    				previousIcon: '',
    				nextIcon: '',
    				galleryFadeIn: 100,
    				galleryFadeOut: 300,
    				filter: '.img-carousel-link'
    			});
    		});
    		
        }

    }
})(jQuery);